import React, { useState } from 'react';
import { useThroughputData } from '../hooks/useThroughputData';
import { FilterBar } from '../components/throughput/FilterBar';
import { KPIStrip } from '../components/throughput/KPIStrip';
import { ThroughputFunnel } from '../components/throughput/ThroughputFunnel';
import { LeadSourceBreakdown } from '../components/throughput/LeadSourceBreakdown';
import { LoanOfficerTable } from '../components/throughput/LoanOfficerTable';
import { Loader2, ChevronDown, ChevronUp } from 'lucide-react';
export function ThroughputDashboard() {
  const {
    isLoading,
    filters,
    setFilters,
    metrics,
    officers,
    filteredLeads,
    filteredOpportunities
  } = useThroughputData();
  const [showSourceBreakdown, setShowSourceBreakdown] = useState(false);
  const handleRefresh = () => {
    window.location.reload();
  };
  const handleRowClick = (officerId: string) => {
    setFilters({
      ...filters,
      scopeType: 'Loan Officer',
      selectedScopeId: officerId
    });
  };
  if (isLoading || !metrics) {
    return <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]" data-id="element-240">
        <div className="flex flex-col items-center" data-id="element-241">
          <div className="w-12 h-12 rounded-xl bg-[#B8960C]/10 flex items-center justify-center mb-4" data-id="element-242">
            <Loader2 className="h-6 w-6 animate-spin text-[#B8960C]" data-id="element-243" />
          </div>
          <p className="text-sm text-[#706E6B]" data-id="element-244">Loading dashboard...</p>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-[#F5F5F5]" data-id="element-245">
      <FilterBar filters={filters} setFilters={setFilters} officers={officers} onRefresh={handleRefresh} data-id="element-246" />

      <main className="max-w-[1600px] mx-auto px-6 py-8" data-id="element-247">
        {/* Page Header */}
        <div className="mb-8" data-id="element-248">
          <h1 className="text-2xl font-semibold text-[#181818] mb-1" data-id="element-249">
            Throughput Dashboard
          </h1>
          <p className="text-[#706E6B]" data-id="element-250">
            Cohort analysis of lead conversion performance
          </p>
        </div>

        {/* KPI Strip */}
        <KPIStrip metrics={metrics} data-id="element-251" />

        {/* Funnel */}
        <ThroughputFunnel metrics={metrics.funnelMetrics} opportunities={filteredOpportunities} data-id="element-252" />

        {/* Lead Source Toggle */}
        <button onClick={() => setShowSourceBreakdown(!showSourceBreakdown)} className="flex items-center gap-2 text-sm font-medium text-[#706E6B] hover:text-[#181818] mt-2 mb-6 transition-colors" data-id="element-253">
          {showSourceBreakdown ? <ChevronUp className="h-4 w-4" data-id="element-254" /> : <ChevronDown className="h-4 w-4" data-id="element-255" />}
          {showSourceBreakdown ? 'Hide' : 'Show'} Lead Source Breakdown
        </button>

        {/* Lead Source Breakdown */}
        {showSourceBreakdown && <LeadSourceBreakdown leads={filteredLeads} opportunities={filteredOpportunities} activeSource={filters.leadSources.length === 1 ? filters.leadSources[0] : null} onSourceClick={source => {
        if (filters.leadSources.length === 1 && filters.leadSources[0] === source) {
          setFilters({
            ...filters,
            leadSources: []
          });
        } else {
          setFilters({
            ...filters,
            leadSources: [source]
          });
        }
      }} data-id="element-256" />}

        {/* Officer Table */}
        <LoanOfficerTable metrics={metrics.officerMetrics} onRowClick={handleRowClick} data-id="element-257" />
      </main>
    </div>;
}